import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "scrollHost",
    class: _normalizeClass(['app-main',_ctx.path==='/main/index'?'main-background':''])
  }, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: route.path
        }))
      ]),
      _: 1
    })
  ], 2))
}